import logo from './logo.svg';
import './App.css';
import {BrowserRouter as Router, Routes, Route, Link} from 'react-router-dom';
import Home from './Components/Home/Home';
import CreatePost from './Components/Home/CreatePost';
import About from './Components/About';
import Login from './Components/Login';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import { useState } from 'react';
import styles from './App.css';
import Competitions from './Components/Cometitions/Competitions';
import CreateComp from './Components/Cometitions/AddCompetition';
import FullPost from './Components/FullPost.js';

function App() {
  const[isAuth, setIsAuth] = useState(false);

  return (
    <Router>
      <Navbar isAuth={isAuth} setIsAuth={setIsAuth}/>
      <Routes>
        <Route path='/' element={<Home isAuth={localStorage.getItem("isAuth")} />} />
        <Route path='/createpost' element={<CreatePost />} />
        <Route path='/onas' element={<About />} />
        <Route path='/post' element={<FullPost />} />
        <Route path='/login' element={<Login setIsAuth={setIsAuth}/>} />
      </Routes>
      <Footer className="footer"/>
    </Router>
  );
}

export default App;
